import * as React from "react";
import { gql, useMutation, MutationHookOptions, MutationTuple } from "@apollo/client";
import {
  CustomerConnectIdReminderMutation,
  CustomerConnectIdReminderMutationVariables
} from "../../../../../schemaTypes";

export const customerConnectIdReminderMutation = gql`
  mutation CustomerConnectIdReminder(
    $id: String!
  ) {
    customerConnectIdReminder(
      id: $id
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface WithCustomerConnectIdReminder {
  customerConnectIdReminder: MutationTuple<
    CustomerConnectIdReminderMutation,
    CustomerConnectIdReminderMutationVariables
  >[0];
}


interface CustomerConnectIdReminderProps {
  children: (data: WithCustomerConnectIdReminder) => React.ReactElement | null;
  options?: MutationHookOptions<
    CustomerConnectIdReminderMutation,
    CustomerConnectIdReminderMutationVariables
  >;
}

export const CustomerConnectIdReminder: React.FC<CustomerConnectIdReminderProps> = ({ children, options }) => {
  const [customerConnectIdReminder] = useMutation<
    CustomerConnectIdReminderMutation,
    CustomerConnectIdReminderMutationVariables
  >(
    customerConnectIdReminderMutation,
    options
  );
  return children({ customerConnectIdReminder });
};